<template>
    <div class="container">
        <section class="search_box" >
            <section class="search_box_inpt">
            <img class="search_icon" src="../../assets/images/search.png" />
            <input ref="search_inp"
                type="text"
                placeholder="搜索下单人手机号"
                v-model="key"
                @input="inputFun"
                maxlength="20"
            />
            <img
                class="clear_img"
                @click.stop="searchClear"
                v-if="key.length"
                src="../../assets/images/btn_clear.png"
            />
            </section>
            <span class="search_btn" v-if="key.length" @click="cancelSearch">取消</span>
        </section>

        <div class="navbar">
            <div
            :class="['navbar_list',activeTab==index ? 'cur' :'']"
            v-for="(item,index) of tabs"
            :key="index"
            @click="tabClick(index)"
            >
                <span>{{item}}</span>
                <i></i>
            </div>
       </div>

       <div class="shop_list"  v-if="approvalArr.length>0">
            <scroll  :allLoaded="allLoaded"
                :data="approvalArr"
                @pulldown="loadData"
                @loadUp="loadup" >
                <!-- @click="goDetail(item)" -->
                <div :class="['list_box' ]" 
                    v-for="(item,index) in approvalArr" :key="index">
                    <div class="list_box_top">
                        <span class="list_box_topSpan1">{{ item.createTime }}</span>
                        <span class="list_box_topSpan2">{{ activeTab==0?'待核销':'已核销' }} </span>
                    </div>
                    <div class="list_box_body">
                        <div class="list_box_body_left">
                            <img class="list_box_body_left_icon" v-if="item.templateType=='1'" src='../../assets/images/img_mall_zfq.png' />
                            <img v-else class="list_box_body_left_icon" :src="item.actImgPath" />
                        </div>
                        <div class="list_box_body_right">
                             <span class="list_box_bodyTitle">{{ item.actName }}</span>  
                             <span v-if ="item.payAmount" class="list_box_bodySpan">实付金额: ￥{{ item.payAmount }}</span> 
                             <span v-if ="item.changeVal" class="list_box_bodySpan">使用积分:{{ item.changeVal }}</span> 
                             <span  class="list_box_bodySpan">下单人: {{ item.phone }}</span>  
                             <span class="list_box_bodySpan">订单编号:{{ item.id }}</span> 


                        </div>

                    </div>
                </div>
            </scroll>
        </div>
        <div class="noMess" v-if="approvalArr.length==0 && loaded">
          <no-message></no-message>
        </div>
    </div>
</template>  


<script>

import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import { mapState } from 'vuex';
import { getVerifiyTradeRecords } from "../../utils/api";
import util from '../../utils/util';
let timer = "";

export default {
  name: "VerifiyTradeRecord",
  components: {
     Scroll,
     NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),10)
      //configObj.formatTime(new Date(val),'-','yyyymmdd');
    }
  },

  data() {
    return {
        tabs: ['待核销','已核销'],
        allLoaded:false,
        loaded:false,
        isLoding:false,
        activeTab: 0,
        orderPhone:'',
        pageNo:1,
        approvalArr:[],
        key:'',
        searchEnd:"",
    }
  },

  created() {
    console.log('in VerifiyTradeRecord')
  },
  activated () {
    this.pageNo =1;
    this.allLoaded =false;
    this.getVerifiyTradeRecordsAction();
    //this.getParkInfo();
    // if (this.parkId !== this.$route.params.id) {
    //   this.parkId = this.$route.params.id;
    //   this.getParkMemberAction();
    // }
  },
  methods: {
    getVerifiyTradeRecordsAction(){
         this.isLoding =true;
         let params = {
            // marketId:  this.common.marketInfo.id,
            // userId: this.common.userId,
            "status": String(this.activeTab) ,
            "pageNo": this.pageNo,
            "pageSize": 10
         }
         if(this.key){
           params.orderPhone=this.key;
         }
        getVerifiyTradeRecords(params).then(res => {
            this.isLoding=false;
            this.loaded =true;
            if (res.res.code === 10000 && res.body) {
               // console.log(res)
                if(this.pageNo==1){
                    this.approvalArr = res.body.mbActiveTradeList;
                } else if(res.body.mbActiveTradeList.length>0){

                    this.approvalArr = this.approvalArr.concat(res.body.mbActiveTradeList);
                }
                if(res.body.mbActiveTradeList.length != 10){
                    this.allLoaded =true;
                }
            }else{
                util.showToast(res.res.msg) 
            }
        });

    },

    tabClick (val) {
      this.activeTab = val;
    //   this.searchClear();
      this.pageNo = 1;
      this.allLoaded =false;
      this.isLoding =false;
      this.getVerifiyTradeRecordsAction();
    },

        //下拉刷新
     loadData(){
       console.log("in loadData");
       if(this.isLoding){
         return;
       }
       this.pageNo=1;
       this.allLoaded =false;
       this.getVerifiyTradeRecordsAction();
     },

     //上拉
     loadup(){
       console.log("in loadup");
       if(this.isLoding){
         return;
       }
       if(this.allLoaded==true){
         return;
       }
       this.pageNo=this.pageNo+1;
       this.getVerifiyTradeRecordsAction();
     },
    
    cancelSearch() {
      //this.$router.go(-1);
      this.searchClear();
      this.$refs.search_inp.blur();
    },
    // 点击清空图标
    searchClear() {
      this.key = "";
      this.searchEnd = 0;
      //this.dataList = [];
      var that =this 
      timer = setTimeout(function() {
          that.loadData();
        }, 500);
    },
    inputFun() {
      //键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
     // that.dataList = [];
      if (that.key.length === 0 && that.key.length === 0) {
        //如果输入框为空
        that.searchEnd = 0;
        timer = setTimeout(function() {
          that.loadData();
        }, 500);
      } else {
        this.searchEnd = 2;
        timer = setTimeout(function() {
          that.loadData();
        }, 500);
      }
    },
  }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EEEEEE;
  .flex(column);
  .shop_list {
    flex: 1;
    height: 500px;
  }
}

.navbar {
  .flex();
  justify-content: center;
  width: 100%;
  height: 94px;
  margin: 0 auto;
  background: #EEEEEE;
  .navbar_list {
    .flex(column);
    text-align: center;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 24px 0 12px;
    span {
      height: 42px;
      line-height: 42px;
      color: @color9;
    }
    i {
      width: 32px;
      height: 6px;
      background: #EEEEEE;
    }
    &.cur {
      span {
        color: @color17;
        font-weight:bold;
      }
      i{
        background: @color17;
      }
    }
  }
}


  .tab-panels {
    position: relative;
    width: 1500px;
    flex-direction: row;
    display: flex;
    /* background-color: #F5F5F5; */
    transition: left 0.2s ease-in-out;
  }

  .serachDiv{
    width: 100%;
    height: 120px;
    display: flex;
    .serach_bg{
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      margin-top: 26px;
      width:710px;
      height:68px;
      background:rgba(248,248,248,1);
      border-radius:8px;
    }
  }

  .list_box{
      position: relative;
      margin-top: 20px;
      margin-left: 20px;
      padding-top: 14px;
      padding-bottom: 14px;
      width:710px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
  }
  .list_box_top{
    margin-top: 10px;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width:670px;
  }
  .list_box_topSpan1{
        font-size:28px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:40px;
  }
  .list_box_topSpan2{
        font-size:32px;
        font-weight:400;
        color:rgba(255,126,30,1);
        line-height:40px;
  }

  .list_box_body{
    margin-top: 10px;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width:670px;
  }
  .list_box_body_left{
    width: 250px;
    height: 180px;
    display: flex;
    .list_box_body_left_icon{
        width: 250px;
        height: 180px;
        display: flex;
    }
  }
  .list_box_body_right{
    margin-left: 20px;
    flex-direction: column;
    width: 400px;
    display: flex;

  }
  .list_box_bodyTitle{
        font-size:32px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;
        .textOver(400px);
  }
  .list_box_bodySpan{
        font-size:28px;
        color:rgba(51,51,51,0.8);
        line-height:44px;
        .textOver(400px);
  }


  .noMess{
    margin-top:300px;
  }
  


.search_box {
  display: flex;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // height: 68px;
  width: 100%;
  height: 120px;
  .flex();
  align-items: center;
  // background:#fff;
  // z-index:2;
  .search_btn {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    display: block;
    padding: 0 32px 0 40px;
  }
  .search_box_inpt {
    flex: 1;
    height: 68px;
    margin-left: 20px;
    margin-right: 20px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    position: relative;
    .flex();
    align-items: center;
    .search_icon {
      width: 44px;
      height: 44px;
      display: block;
      margin: 0 14px;
    }
    input {
      flex: 1;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      background: transparent;
      height: 68px;
    }
    .clear_img {
      position: absolute;
      width: 44px;
      height: 44px;
      padding: 12px;
      top: 0;
      right: 0;
    }
  }
}


</style>